"use client";
import { Card } from "@fanduel/og-fe-library";
import React, { useState } from "react";
import { STANDINGS_CONFERENCE_SELECTED } from "@/constants/amplitude";
import { TeamByConferenceDivisionT } from "@/types/divisionStandings";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { filterEmpty } from "@/utils/index";
import ButtonToggle from "../buttonToggle";
import RecordTable from "./RecordTable";
import Styles from "./Standings.module.scss";

interface DivisionStandingsClientProps {
  teamsByDivision: TeamByConferenceDivisionT;
}

export default function DivisionStandingsClient({
  teamsByDivision,
}: DivisionStandingsClientProps) {
  const [conference, setConference] = useState<string>("AFC");

  const selectedConferenceDivisions = teamsByDivision[conference];
  const divisions = Object.keys(selectedConferenceDivisions);
  const date = new Date();
  const year = date.getFullYear();

  const { logAmplitudeEvent } = useAmplitude();

  return (
    <div className={Styles.standingsWrapper}>
      <Card
        className={Styles.standingsCard}
        elevation="mid"
        rounded="sm"
        variant="elevation"
        testId="standings-card"
      >
        <div className={Styles.contentContainer}>
          <h2>{year} NFL Divisional Standings</h2>
          <div className={Styles.toggleContainer}>
            <ButtonToggle
              options={["AFC", "NFC"]}
              onTabChange={(conf) => {
                logAmplitudeEvent(STANDINGS_CONFERENCE_SELECTED, {
                  Module: "standings",
                  "Item Selected": conf,
                  Competition: "NFL",
                });
                setConference(conf);
              }}
              activeTab={conference}
            />
          </div>

          <div className={Styles.tableContainer}>
            {divisions.map((division) => (
              <div key={division} className={Styles.divisionSection}>
                <h3>{`${division}`}</h3>
                <p className={Styles.tableHeader}>
                  <span>Team</span>
                  <span className={Styles.gamesList}>
                    <span>Last 5</span>
                    <span>Next</span>
                  </span>
                </p>
                <div className={Styles.teamRowContainer}>
                  {filterEmpty(selectedConferenceDivisions[division] ?? []).map(
                    (team) => (
                      <RecordTable key={team.meta?.code} team={team} />
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}
